import { queryHtmlElement } from "../core/dom";

/**
 * Handles focus for server-rendered lost-password validation and status messages.
 */
export class LostPasswordController {
  private readonly alert: HTMLElement | null;

  public constructor(root: HTMLElement) {
    this.alert = queryHtmlElement(root, "[data-lost-password-alert]", HTMLElement);
  }

  public connect(): void {
    this.alert?.focus();
  }
}
